
import React from "react";
import {router, usePage} from "@inertiajs/react";
import {useLaravelReactI18n} from "laravel-react-i18n";
import InertiaTable from "laravel-inertia-react-table";
import {mdiPlus} from "@mdi/js";
import Icon from "@mdi/react";
import {Button} from "react-bootstrap";

export default function Reports(props) {
    const { t } = useLaravelReactI18n();
    const { reports } = usePage().props;


  const handleRowClick = (report) => {
    window.location.href = 'report/download?id='+report.id;
  }

  return (<InertiaTable title={t('Reports')} data={ reports } onRowClick={handleRowClick}/>);
}



